import {
  createApi, fetchBaseQuery,
} from '@reduxjs/toolkit/query/react';
import { KEYCLOAK_API } from '../../configs/endpoints';
import { TokenDto } from './dto';
import { KEYCLOAK_CLIENT_ID } from '../../configs/credentials';
import { connectionTimeout } from '../../configs/initialValues';

const baseQuery = fetchBaseQuery({
  baseUrl: KEYCLOAK_API,
  timeout: connectionTimeout,
});

const api = createApi({
  reducerPath: 'keycloak-api',
  baseQuery,
  endpoints: (builder) => ({
    getLoggedIn: builder.mutation<TokenDto, {username: string, password: string}>({
      query: ({ username, password }) => ({
        url: 'protocol/openid-connect/token',
        method: 'POST',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          username,
          password,
          grant_type: 'password',
          client_id: KEYCLOAK_CLIENT_ID,
        }),
      }),
    }),
  }),
});

export const {
  useGetLoggedInMutation,
} = api;

export default api;
